// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3420":"31d6cfe0","4329":"31d6cfe0","6756":"529b550c"}[chunkId] + ".chunk.css";
};